<section class="expand-panel" data-crlat="panelExpand">
    <header class="expand-panel-heading" (click)="openPanel = !openPanel" [ngClass]="{ active: openPanel }" data-crlat="panelHeader">
        <div [textContent]="openPanel ? hideCashoutHistory : showCashoutHistory" data-crlat="title"></div>
        <svg>
            <use [attr.xlink:href]="openPanel ? '#up-arrow' : '#down-arrow'"></use>
        </svg>
    </header>
    <div class="expand-panel-body" *ngIf="openPanel" data-crlat="panelBody">
        <ng-content></ng-content>
    </div>
</section>
